<div class="invalidez-home">

  <ds-skeleton variant="card" *ngIf="loading" />

  <app-ds-generic-error *ngIf="!loading && isError && errorOps" [ops]="errorOps">
  </app-ds-generic-error>

  <ng-container *ngIf="!loading && !isError && preguntaPrePaso0">
    <app-pi-pregunta-paso-0 (continuarPaso0)="onContinuarPaso0()"></app-pi-pregunta-paso-0>
  </ng-container>
  <ng-container *ngIf="!loading && !isError && !preguntaPrePaso0">

    <app-pi-hero-card (queEsPension)="onQueEsPension()" (revisaPasos)="onRevisaPasos()">
    </app-pi-hero-card>

    <app-pi-requisitos-card></app-pi-requisitos-card>

    <app-pi-exclusiones-card (agendarVideoAtencion)="onAgendarVideoAtencion()">
    </app-pi-exclusiones-card>

    <app-pi-confirmacion-card
      [loading]="iniciandoSolicitud"
      (iniciarSolicitud)="onIniciarSolicitud()"
      (abrirInfoImportante)="onAbrirInfoImportante()">
    </app-pi-confirmacion-card>
  </ng-container>  
</div>